import React from 'react'
import { Carousel } from 'msp-components'
import { Region } from 'msp-integrations'
import { GalleryTextProps } from './GalleryText.types'
import * as S from './GalleryText.styles'

const GalleryText = ({
  galleryPosition = 'left',
  images,
  content
}: GalleryTextProps) => {
  return (
    <div
      className={`flex ${
        galleryPosition === 'left'
          ? 'flex-col md:flex-row'
          : 'flex-col-reverse md:flex-row-reverse'
      }`}
    >
      <div className={`${S.carouselWrapper}`}>
        <Carousel
          productImages={images}
          autoplay
          hideControl={images.length < 2}
        />
      </div>
      <div
        className={`${S.contentWrapper} ${
          galleryPosition === 'right' ? 'md:mr-auto' : ''
        }`}
      >
        <Region region={content} />
      </div>
    </div>
  )
}

export default GalleryText
